import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { QUESTION_LEVEL, questionLevelType } from '../../constants/system';
import { Question } from '../../types/quiz';

export interface Quiz {
  activeLevel: questionLevelType;
  selectSkillOpened: boolean;
  skillName?: string;
  questionModal?: {
    isOpened?: boolean;
    mode?: 'ADD' | 'EDIT';
    question?: { index: number } & Question;
    status?: 'PENDING' | 'FINISHED';
  };
  filters?: {
    speciality: number;
    requestId: number;
    statusCode: string;
  };
}

const initialState: Quiz = {
  activeLevel: QUESTION_LEVEL.easy,
  selectSkillOpened: false,
};

export const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    changeActiveLevel: (state, action) => {
      state.activeLevel = action.payload;
    },

    setSelectSkillOpened: (state, action) => {
      state.selectSkillOpened = action.payload;
    },

    setSkillName: (state, action) => {
      state.skillName = action.payload;
    },

    setQuestionModal: (state, action) => {
      state.questionModal = action.payload;
    },

    resetQuestionModal: (state) => {
      state.questionModal = {};
    },

    setFilters: (state, actions) => {
      state.filters = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  changeActiveLevel,
  setSelectSkillOpened,
  setSkillName,
  setQuestionModal,
  resetQuestionModal,
  setFilters,
} = quizSlice.actions;
export const useQuizState = () =>
  useSelector((state: RootState) => state?.quiz);

export default quizSlice.reducer;
